export default API => {
    const getAllShipping = async () => {
        try {
            const {
                data: { shipping },
            } = await API.get(`/client-settings/shipping`)
            return shipping
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllFinish = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(`/client-settings/finish?settingId=${settingId}`)
            return finishes
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createFinish = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finish`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateFinish = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finish`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteFinish = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finish?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllFinishHPL = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(
                `/client-settings/finishHPL?settingId=${settingId}`
            )
            return finishes
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }
    const getAllFinishAluminum = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(
                `/client-settings/finishAluminum?settingId=${settingId}`
            )
            return finishes
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }
    const createFinishHPL = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finishHPL`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateFinishHPL = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finishHPL`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteFinishHPL = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finishHPL?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    /** Grilla `finishBrakeMetalsGrid` (pa-api conserva `finishBrakeMetals` para el cotizador). */
    const getAllFinishBrakeMetals = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(
                `/client-settings/finishBrakeMetalsGrid?settingId=${settingId}`
            )
            return finishes
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createFinishBrakeMetals = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finishBrakeMetalsGrid`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateFinishBrakeMetals = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finishBrakeMetalsGrid`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteFinishBrakeMetals = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finishBrakeMetalsGrid?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllFinishBrakeMetalsCatalog = async settingId => {
        try {
            const {
                data: { finishes },
            } = await API.get(
                `/client-settings/finishBrakeMetals?settingId=${settingId}`
            )
            return finishes
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createFinishBrakeMetalsCatalog = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finishBrakeMetals`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateFinishBrakeMetalsCatalog = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finishBrakeMetals`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteFinishBrakeMetalsCatalog = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finishBrakeMetals?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createFinishAluminum = async params => {
        try {
            const {
                data: { finish },
            } = await API.post(`/client-settings/finishAluminum`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateFinishAluminum = async params => {
        try {
            const {
                data: { finish },
            } = await API.put(`/client-settings/finishAluminum`, params)
            return finish
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteFinishAluminum = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/finishAluminum?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllProfiles = async settingId => {
        try {
            const {
                data: { profiles },
            } = await API.get(`/client-settings/profile?settingId=${settingId}`)
            return profiles
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createProfile = async params => {
        try {
            const {
                data: { profile },
            } = await API.post(`/client-settings/profile`, params)
            return profile
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateProfile = async params => {
        try {
            const {
                data: { profile },
            } = await API.put(`/client-settings/profile`, params)
            return profile
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteProfile = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/profile?id=${id}&settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllValueInputs = async settingId => {
        try {
            const {
                data: { valueInputs },
            } = await API.get(
                `/client-settings/value-inputs?settingId=${settingId}`
            )
            return valueInputs
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateValueInput = async params => {
        try {
            const {
                data: { valueInput },
            } = await API.put(`/client-settings/value-inputs`, params)
            return valueInput
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createBrakeMetalsMaterial = async ({
        settingId,
        name,
        costPerKg,
        currency,
    }) => {
        try {
            const {
                data: { valueInput },
            } = await API.post(
                '/client-settings/value-inputs/brake-metals-material',
                { settingId, name, costPerKg, currency }
            )
            return valueInput
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createClientSetting = async () => {
        try {
            const {
                data: { setting },
            } = await API.post('/client-settings')
            return setting
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getLaborCostPerModule = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.get(
                `/client-settings/labor-cost-per-module?settingId=${settingId}`
            )
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createLaborCostPerModule = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.post('/client-settings/labor-cost-per-module', {
                settingId,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateLaborCostPerModule = async ({
        settingId,
        id,
        paramsToUpdate,
    }) => {
        try {
            const {
                data: { response },
            } = await API.put('/client-settings/labor-cost-per-module', {
                settingId,
                id,
                paramsToUpdate,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getLouverSizingTable = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.get(
                `/client-settings/louver-sizing-table?settingId=${settingId}`
            )
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createLouverSizingTable = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.post('/client-settings/louver-sizing-table', {
                settingId,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateLouverSizingTable = async ({
        settingId,
        model,
        byDimension,
        byWeight,
    }) => {
        try {
            const {
                data: { response },
            } = await API.put('/client-settings/louver-sizing-table', {
                settingId,
                model,
                byDimension,
                byWeight,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getLamitechPanelPrices = async ({ settingId }) => {
        try {
            const {
                data: { response },
            } = await API.get(
                `/client-settings/lamitech-panel-prices?settingId=${settingId}`
            )
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createLamitechPanelPrices = async ({ settingId, items }) => {
        try {
            const {
                data: { response },
            } = await API.post('/client-settings/lamitech-panel-prices', {
                settingId,
                items,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateLamitechPanelPrices = async ({
        settingId,
        id,
        paramsToUpdate,
    }) => {
        try {
            const {
                data: { response },
            } = await API.put('/client-settings/lamitech-panel-prices', {
                settingId,
                id,
                paramsToUpdate,
            })
            return response
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getCalculator = async quoteId => {
        try {
            const {
                data: { calculator },
            } = await API.get(`/quotes/calculator?quoteId=${quoteId}`)
            return calculator
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const createModel = async ({
        settingId,
        name,
        file,
        modelType,
        doubleAngleFile,
        fpaFile,
        cadFile,
        specsFile,
        installationManualFile,
    }) => {
        try {
            const {
                data: { model },
            } = await API.post(`/client-settings/models`, {
                settingId,
                name,
                file,
                ...(modelType ? { modelType } : {}),
                ...(doubleAngleFile ? { doubleAngleFile } : {}),
                ...(fpaFile ? { fpaFile } : {}),
                ...(cadFile ? { cadFile } : {}),
                ...(specsFile ? { specsFile } : {}),
                ...(installationManualFile ? { installationManualFile } : {}),
            })
            return model
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getModels = async ({ settingId }) => {
        try {
            const {
                data: { models },
            } = await API.get(`/client-settings/models?settingId=${settingId}`)
            return models
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateModel = async ({
        settingId,
        id,
        name,
        file,
        modelType,
        doubleAngleFile,
        fpaFile,
        cadFile,
        specsFile,
        installationManualFile,
    }) => {
        try {
            const {
                data: { model },
            } = await API.put(`/client-settings/models`, {
                settingId,
                id,
                name,
                file,
                ...(modelType ? { modelType } : {}),
                ...(doubleAngleFile ? { doubleAngleFile } : {}),
                ...(fpaFile ? { fpaFile } : {}),
                ...(cadFile ? { cadFile } : {}),
                ...(specsFile ? { specsFile } : {}),
                ...(installationManualFile ? { installationManualFile } : {}),
            })
            return model
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteModel = async ({ settingId, id }) => {
        try {
            const {
                data: { model },
            } = await API.delete(
                `/client-settings/models?settingId=${settingId}&id=${id}`
            )
            return model
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const saveVideo = async ({ settingId, url }) => {
        try {
            const {
                data: { video },
            } = await API.post(`/client-settings/videotutorial`, {
                settingId,
                url,
            })
            return video
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getVideo = async ({ settingId }) => {
        try {
            const {
                data: { video },
            } = await API.get(
                `/client-settings/videotutorial?settingId=${settingId}`
            )
            return video
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getClientSettingRoleAssignments = async settingId => {
        try {
            const { data } = await API.get(
                `/client-settings/role-assignments?settingId=${settingId}`
            )
            return {
                roleAssignmentsByModel: data?.roleAssignmentsByModel || {},
                documentReviewUserId: data?.documentReviewUserId ?? null,
            }
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateClientSettingRoleAssignments = async (
        settingId,
        roleAssignmentsByModel,
        documentReviewUserId
    ) => {
        try {
            const { data } = await API.put(
                '/client-settings/role-assignments',
                {
                    settingId,
                    roleAssignmentsByModel,
                    documentReviewUserId,
                }
            )
            return {
                roleAssignmentsByModel: data?.roleAssignmentsByModel || {},
                documentReviewUserId: data?.documentReviewUserId ?? null,
            }
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getClientSalesFormats = async settingId => {
        try {
            const {
                data: { salesFormats, documentTypes },
            } = await API.get(
                `/client-settings/sales-formats?settingId=${settingId}`
            )
            return {
                salesFormats: salesFormats || {},
                documentTypes: Array.isArray(documentTypes)
                    ? documentTypes
                    : [],
            }
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const saveClientSalesFormat = async ({ settingId, type, file }) => {
        try {
            const {
                data: { salesFormats },
            } = await API.post('/client-settings/sales-formats', {
                settingId,
                type,
                file,
            })
            return salesFormats || {}
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteClientSalesFormat = async ({ settingId, type }) => {
        try {
            const {
                data: { salesFormats },
            } = await API.delete(
                `/client-settings/sales-formats?settingId=${settingId}&type=${type}`
            )
            return salesFormats || {}
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const saveTutorial = async ({ settingId, model, url, fileName, name }) => {
        try {
            const {
                data: { tutorial },
            } = await API.post(`/client-settings/tutorial`, {
                settingId,
                model,
                url,
                fileName,
                name,
            })
            return tutorial
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getTutorial = async ({ settingId, model }) => {
        try {
            const {
                data: { tutorial },
            } = await API.get(
                `/client-settings/tutorial?settingId=${settingId}&model=${model}`
            )
            return tutorial
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getAllLouverScopeDescriptions = async settingId => {
        try {
            const {
                data: { descriptions },
            } = await API.get(
                `/client-settings/louverScopeDescriptions?settingId=${settingId}`
            )
            return descriptions
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getLouverScopeDescription = async ({ settingId, model }) => {
        try {
            const {
                data: { description },
            } = await API.get(
                `/client-settings/louverScopeDescriptions/${encodeURIComponent(
                    model
                )}?settingId=${settingId}`
            )
            return description
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const upsertLouverScopeDescription = async params => {
        try {
            const {
                data: { description },
            } = await API.put(
                `/client-settings/louverScopeDescriptions`,
                params
            )
            return description
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const getCustomLocations = async settingId => {
        try {
            const {
                data: { customLocations },
            } = await API.get(
                `/client-settings/custom-locations?settingId=${settingId}`
            )
            return customLocations
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const addCustomLocation = async params => {
        try {
            const {
                data: { customLocation },
            } = await API.post(`/client-settings/custom-locations`, params)
            return customLocation
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const updateCustomLocation = async params => {
        try {
            const {
                data: { customLocation },
            } = await API.put(
                `/client-settings/custom-locations/${params.id}`,
                params
            )
            return customLocation
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    const deleteCustomLocation = async ({ settingId, id }) => {
        try {
            await API.delete(
                `/client-settings/custom-locations/${id}?settingId=${settingId}`
            )
        } catch (error) {
            const errorResponse = error.response?.data || {}
            throw new Error(
                errorResponse.message || errorResponse.error || error.message
            )
        }
    }

    return {
        deleteModel,
        updateModel,
        getModels,
        createModel,
        getAllShipping,
        getAllFinish,
        getAllFinishHPL,
        getAllFinishBrakeMetals,
        getAllFinishBrakeMetalsCatalog,
        getAllFinishAluminum,
        createFinish,
        updateFinish,
        deleteFinish,
        createFinishHPL,
        updateFinishHPL,
        deleteFinishHPL,
        createFinishBrakeMetals,
        updateFinishBrakeMetals,
        deleteFinishBrakeMetals,
        createFinishBrakeMetalsCatalog,
        updateFinishBrakeMetalsCatalog,
        deleteFinishBrakeMetalsCatalog,
        getAllProfiles,
        createProfile,
        updateProfile,
        deleteProfile,
        getAllValueInputs,
        updateValueInput,
        createBrakeMetalsMaterial,
        createClientSetting,
        getLaborCostPerModule,
        createLaborCostPerModule,
        updateLaborCostPerModule,
        getLouverSizingTable,
        createLouverSizingTable,
        updateLouverSizingTable,
        getCalculator,
        saveVideo,
        getVideo,
        saveTutorial,
        getTutorial,
        getAllLouverScopeDescriptions,
        getLouverScopeDescription,
        upsertLouverScopeDescription,
        getLamitechPanelPrices,
        createLamitechPanelPrices,
        updateLamitechPanelPrices,
        createFinishAluminum,
        updateFinishAluminum,
        deleteFinishAluminum,
        getClientSettingRoleAssignments,
        updateClientSettingRoleAssignments,
        getClientSalesFormats,
        saveClientSalesFormat,
        deleteClientSalesFormat,
        getCustomLocations,
        addCustomLocation,
        updateCustomLocation,
        deleteCustomLocation,
    }
}
